import { useElements, useStripe } from "@stripe/react-stripe-js";
import React from "react";
import { Message } from "components/Atoms/Message";
import { Button } from "semantic-ui-react";
import StripeSetupIntentForm from "../StripeSetupIntentForm";

interface Props {
  clientSecret: string
  returnUrl: string
  onHasLoaded: () => void
  isLoading: boolean
}

const StripePaymentMethod = (props: Props) => {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = React.useState(null);
  const [isSaving, setIsSaving] = React.useState(false);
  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    setIsSaving(true);

    let error: string;
    try {
      const stripeResult = await stripe.confirmSetup({
        // `Elements` instance that was used to create the Payment Element
        elements,
        confirmParams: {
          return_url: props.returnUrl
        }
      });

      if (stripeResult.error) {
        error = stripeResult.error.message;
      }
    } catch {
      error = RESX.GeneralLabels.SomethingUnexpectedHappened;
    }

    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      setErrorMessage(error);
      setIsSaving(false);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };

  const canSubmit = !props.isLoading && stripe && elements && !isSaving;

  return <form onSubmit={handleSubmit}>
    {props.clientSecret &&
      <StripeSetupIntentForm
        onHasLoaded={props.onHasLoaded}
        hasLoaded={!props.isLoading}
      />}
    <div className="flex justify-end margin-top-large">
      <div className="grow1 margin-right">
        {errorMessage && <Message type="error">{errorMessage}</Message>}
      </div>
      <div>
        <Button primary loading={isSaving} disabled={!canSubmit}>{RESX.Buttons.btnSave}</Button>
      </div>
    </div>
  </form>;
};

export default StripePaymentMethod;